/* Corporate gifting quote form (corp-quote). Ported from example/corporate-gifting.html.
   Name, email, occasion: required (spaces alone don't count); email in the Worker's format; company optional; phone
   optional, 7–15 digits.
   Quantity: whole numbers, at least data-min-qty. Needed by: typed MM/DD/YYYY (US) or picked from the
   calendar, at least LEAD_DAYS from today. Products: at least one card ticked (when the section lists any).
   Errors show under each field on blur, and all at once on submit. The form posts to Shopify's contact endpoint;
   without JS the browser's own validation applies.
   With data-proxy set, a copy of the request also goes to the App Proxy (corp-quote Worker → Google Sheet + Slack). */
(function () {
  if (window.__corpLoaded) return;
  window.__corpLoaded = true;

  // Production + delivery lead time; the Worker only rejects past dates
  var LEAD_DAYS = 5;
  // Same pattern as workers/corp-quote/src/validate.ts, so a copy the form lets through isn't rejected there
  var EMAIL = /^[^\s@]+@[^\s@]+\.[^\s@]+$/;

  function requiredMsg(msg) { return function (v) { return v ? '' : msg; }; }
  // Checked against the trimmed value; keyed by data-corp-key
  var RULES = {
    first_name: requiredMsg('Please enter your first name.'),
    last_name: requiredMsg('Please enter your last name.'),
    email: function (v) {
      if (!v) return 'Please enter your work email.';
      return EMAIL.test(v) ? '' : 'Please enter a valid email, e.g. name@company.com.';
    },
    phone: function (v) {
      if (!v) return '';
      if (!/^[\d\s+().-]+$/.test(v)) return 'Please use digits, spaces and + ( ) - only.';
      var n = v.replace(/\D/g, '').length;
      return (n >= 7 && n <= 15) ? '' : 'Please enter a phone number with 7 to 15 digits.';
    },
    occasion: requiredMsg('Please choose an occasion.')
  };

  function pad(n) { return (n < 10 ? '0' : '') + n; }
  function today() { var t = new Date(); t.setHours(0, 0, 0, 0); return t; }
  function earliest() { var t = today(); t.setDate(t.getDate() + LEAD_DAYS); return t; }
  function fmtUS(d) { return pad(d.getMonth() + 1) + '/' + pad(d.getDate()) + '/' + d.getFullYear(); }
  function parseUS(v) {
    var m = /^(\d{2})\/(\d{2})\/(\d{4})$/.exec(v); if (!m) return null;
    var d = new Date(+m[3], +m[1] - 1, +m[2]);
    return (d.getMonth() === +m[1] - 1 && d.getDate() === +m[2]) ? d : null;
  }
  function mark(input, hint, msg, idle) {
    input.classList.toggle('is-invalid', !!msg);
    input.setAttribute('aria-invalid', msg ? 'true' : 'false');
    if (!hint) return;
    hint.classList.toggle('is-error', !!msg);
    hint.textContent = msg || idle || '';
  }

  function submissionId() {
    if (window.crypto && typeof window.crypto.randomUUID === 'function') return window.crypto.randomUUID();
    return Date.now().toString(36) + '-' + Math.random().toString(36).slice(2, 10);
  }

  /* The id outlives the page load until Shopify shows the success panel: when it re-renders the form (form.errors)
     or sends the visitor through its CAPTCHA page, the next submit reuses the id and the Worker drops the second
     copy. Without sessionStorage (private mode, blocked storage) each page load gets a new id, as before. */
  function sidKey(f) { return 'corp-sid:' + (f.id || 'form'); }
  function storedSid(f) {
    try { return window.sessionStorage.getItem(sidKey(f)); } catch (err) { return null; }
  }
  function storeSid(f, id) {
    try { window.sessionStorage.setItem(sidKey(f), id); } catch (err) { /* storage blocked: id lasts this page load */ }
  }
  function clearSid(f) {
    try { window.sessionStorage.removeItem(sidKey(f)); } catch (err) { /* storage blocked: nothing was stored */ }
  }

  /* GTM lead event. The lead is saved at a valid submit and pushed once, on the load that shows Shopify's success
     panel; removing it first means a refresh of that page doesn't count the quote again. event_id carries the
     submission id, so a conversion matches its Sheet row. lead_email / lead_phone are PII: map them only to tags
     built for it (Ads Enhanced Conversions, Meta Advanced Matching), never to GA4 parameters. */
  var LEAD_TTL = 30 * 60 * 1000;
  function leadKey(f) { return 'corp-lead:' + (f.id || 'form'); }
  function saveLead(f, id) {
    var lead = { sid: id, ts: Date.now() };
    ['email', 'phone', 'quantity', 'occasion'].forEach(function (key) {
      var el = f.querySelector('[data-corp-key="' + key + '"]');
      lead[key] = el ? el.value.trim() : '';
    });
    try { window.sessionStorage.setItem(leadKey(f), JSON.stringify(lead)); } catch (err) { console.warn('[corp] lead not saved for GTM', err); }
  }
  function pushLead(f) {
    var lead;
    try {
      var raw = window.sessionStorage.getItem(leadKey(f));
      window.sessionStorage.removeItem(leadKey(f));
      if (!raw) return;
      lead = JSON.parse(raw);
    } catch (err) { console.warn('[corp] saved lead unreadable, GTM event skipped', err); return; }
    if (!lead || Date.now() - lead.ts > LEAD_TTL) return;
    var phone = (lead.phone || '').replace(/\D/g, '');
    if (phone.length === 10) phone = '1' + phone;
    window.dataLayer = window.dataLayer || [];
    window.dataLayer.push({
      event: 'corporate_quote_submitted',
      event_id: 'quote_' + lead.sid,
      brand: 'cobas_daughter',
      lead_email: (lead.email || '').toLowerCase(),
      lead_phone: phone ? '+' + phone : '',
      lead_quantity: lead.quantity,
      lead_occasion: lead.occasion
    });
  }

  /* Form fillers (and some autofill) overwrite hidden inputs too; a wrong form_type makes Shopify drop the post.
     Snapshot the hidden inputs the page rendered (defaultValue won't do: for type=hidden it follows .value), and
     put them back before submit. Inputs added later, such as Shopify's CAPTCHA token, aren't in the snapshot.
     The honeypot is a text input and is left alone on purpose: clearing it would switch it off for the Worker. */
  function snapshotHidden(f) {
    return [].slice.call(f.querySelectorAll('input[type="hidden"]')).map(function (el) { return [el, el.value]; });
  }
  function restoreHidden(snapshot, idEl, id) {
    snapshot.forEach(function (pair) { if (pair[0].value !== pair[1]) pair[0].value = pair[1]; });
    if (idEl) idEl.value = id;
  }

  /* Fire-and-forget: keepalive lets the request finish while the native submit navigates away. */
  function sendCopy(f, proxy, minQty) {
    var body = new URLSearchParams();
    // The page's minimum (corp.min_qty, editable in Admin) travels with the copy so the Worker checks the same rule
    body.set('min_qty', String(minQty));
    [].slice.call(f.querySelectorAll('[data-corp-key]')).forEach(function (el) {
      var key = el.getAttribute('data-corp-key');
      body.set(key, el.type === 'checkbox' ? (el.checked ? 'yes' : '') : el.value.trim());
    });
    [].slice.call(f.querySelectorAll('[data-corp-product]:checked')).forEach(function (el) {
      body.append('products', el.getAttribute('data-corp-product'));
    });
    body.set('page_url', window.location.href.split('#')[0]);
    try {
      fetch(proxy, { method: 'POST', body: body, keepalive: true, credentials: 'same-origin' })
        .then(function (r) { if (!r.ok) console.warn('[corp] quote copy rejected: HTTP ' + r.status); })
        .catch(function (err) { console.warn('[corp] quote copy not sent', err); });
    } catch (err) { console.warn('[corp] quote copy not sent', err); }
  }

  function initForm(f) {
    if (f.hasAttribute('data-corp-ready')) return;
    f.setAttribute('data-corp-ready', '');
    f.noValidate = true;
    // Sent: the next quote from this tab gets a new id
    if (f.querySelector('.corp-success')) { clearSid(f); pushLead(f); }
    // Kept here rather than read back from the field, so both posts of a submit share it.
    var sid = storedSid(f) || submissionId();
    // A second submit (double-click, Enter while navigating) is dropped: it would post the contact form and the
    // copy again. Reset when the page comes back from the back/forward cache so the form can be sent again (same id:
    // the Worker keeps the first copy, Shopify emails both).
    var sent = false;
    window.addEventListener('pageshow', function (e) { if (e.persisted) sent = false; });
    var hidden = snapshotHidden(f);
    var sidEl = f.querySelector('[data-corp-key="submission_id"]');

    var fields = Object.keys(RULES).map(function (key) {
      var el = f.querySelector('[data-corp-key="' + key + '"]');
      if (!el) return null;
      var field = { el: el, hint: f.querySelector('[data-corp-hint="' + key + '"]') };
      field.err = function () { return RULES[key](el.value.trim()); };
      // Empty fields aren't flagged while tabbing through; submit flags them
      el.addEventListener('blur', function () {
        if (el.value.trim() || el.classList.contains('is-invalid')) mark(el, field.hint, field.err());
      });
      el.addEventListener(el.tagName === 'SELECT' ? 'change' : 'input', function () {
        if (el.classList.contains('is-invalid') && !field.err()) mark(el, field.hint, '');
      });
      return field;
    }).filter(Boolean);

    var MIN = parseInt(f.getAttribute('data-min-qty'), 10) || 25;
    var qty = f.querySelector('[data-corp-qty]'), qhint = f.querySelector('[data-corp-qty-hint]');
    var qidle = qhint ? qhint.textContent : '';
    function qtyErr() {
      var v = qty.value.trim();
      return (/^\d+$/.test(v) && parseInt(v, 10) >= MIN) ? '' : 'Please enter ' + MIN + ' or more.';
    }
    if (qty) {
      qty.addEventListener('keydown', function (e) { if (['e', 'E', '+', '-', '.', ','].indexOf(e.key) > -1) e.preventDefault(); });
      qty.addEventListener('input', function () {
        var d = qty.value.replace(/\D/g, ''); if (d !== qty.value) qty.value = d;
        if (qty.classList.contains('is-invalid') && !qtyErr()) mark(qty, qhint, '', qidle);
      });
      qty.addEventListener('blur', function () { if (qty.value !== '') mark(qty, qhint, qtyErr(), qidle); });
    }

    var dt = f.querySelector('[data-corp-date]'), dhint = f.querySelector('[data-corp-date-hint]');
    var dnat = f.querySelector('[data-corp-date-native]'), dbtn = f.querySelector('[data-corp-date-btn]');
    function dateErr() {
      var v = dt.value.trim(); if (!v) return '';
      var d = parseUS(v); if (!d) return 'Please use MM/DD/YYYY.';
      if (d < earliest()) return 'Please allow at least ' + LEAD_DAYS + ' days: choose ' + fmtUS(earliest()) + ' or later.';
      return '';
    }
    if (dt) {
      dt.addEventListener('input', function () {
        var d = dt.value.replace(/\D/g, '').slice(0, 8), o = d.slice(0, 2);
        if (d.length > 2) o += '/' + d.slice(2, 4);
        if (d.length > 4) o += '/' + d.slice(4);
        dt.value = o;
        if (dt.classList.contains('is-invalid') && !dateErr()) mark(dt, dhint, '');
      });
      dt.addEventListener('blur', function () { mark(dt, dhint, dateErr()); });
      if (dnat && dbtn) {
        var t = earliest(); dnat.min = t.getFullYear() + '-' + pad(t.getMonth() + 1) + '-' + pad(t.getDate());
        dbtn.addEventListener('click', function () {
          var d = parseUS(dt.value); if (d) dnat.value = d.getFullYear() + '-' + pad(d.getMonth() + 1) + '-' + pad(d.getDate());
          try { dnat.showPicker(); } catch (err) { dnat.style.pointerEvents = 'auto'; dnat.focus(); dnat.click(); }
        });
        dnat.addEventListener('change', function () {
          var p = dnat.value.split('-'); if (p.length === 3) { dt.value = p[1] + '/' + p[2] + '/' + p[0]; mark(dt, dhint, dateErr()); }
        });
      }
    }

    var pgrid = f.querySelector('[data-corp-products]'), phint = f.querySelector('[data-corp-products-hint]');
    function productsErr() {
      return f.querySelector('[data-corp-product]:checked') ? '' : 'Please select at least 1 product.';
    }
    if (pgrid) {
      pgrid.addEventListener('change', function () {
        if (phint && phint.classList.contains('is-error') && !productsErr()) { phint.classList.remove('is-error'); phint.textContent = ''; }
      });
    }

    f.addEventListener('submit', function (e) {
      if (sent) { e.preventDefault(); return; }
      // Every invalid field is flagged at once; focus goes to the first one (fields, qty, date, products: DOM order)
      var invalid = [];
      fields.forEach(function (field) {
        var msg = field.err();
        mark(field.el, field.hint, msg);
        if (msg) invalid.push(field.el);
      });
      var qe = qty ? qtyErr() : '';
      if (qe) { mark(qty, qhint, qe, qidle); invalid.push(qty); }
      var de = dt ? dateErr() : '';
      if (de) { mark(dt, dhint, de); invalid.push(dt); }
      var pe = pgrid ? productsErr() : '';
      if (pe) {
        if (phint) { phint.classList.add('is-error'); phint.textContent = pe; }
        var first = pgrid.querySelector('[data-corp-product]');
        if (first) invalid.push(first);
      }
      if (invalid.length) { e.preventDefault(); invalid[0].focus(); return; }
      if (!f.checkValidity()) { e.preventDefault(); f.reportValidity(); return; }
      // Runs before the browser builds the POST body, so the native submit sends the restored values too.
      restoreHidden(hidden, sidEl, sid);
      storeSid(f, sid);
      saveLead(f, sid);
      sent = true;
      var proxy = f.getAttribute('data-proxy');
      if (proxy) sendCopy(f, proxy, MIN);
    });
  }

  function init(root) { [].slice.call((root || document).querySelectorAll('.corp-form')).forEach(initForm); }

  if (document.readyState === 'loading') document.addEventListener('DOMContentLoaded', function () { init(document); });
  else init(document);
  document.addEventListener('shopify:section:load', function (e) { init(e.target); });
})();
